/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Panel,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import roadtestActions from 'loraactions/roadtest';
import SelectGatewayModal from 'loracoms/SelectGatewayModal';
import Refresher from 'loracoms/Refresher';
import CoverageModal from '../CoverageModal';
import DeviceModal from '../DeviceModal';
import TimeSelect from '../TimeSelect';
import GpsColor from '../GpsColor';
import styles from './styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  getDevice: PropTypes.func.isRequired,
  getGateway: PropTypes.func.isRequired,
  getGpsColor: PropTypes.func.isRequired,
  getRadius: PropTypes.func.isRequired,
  updateGps: PropTypes.func.isRequired,
  startDwnld: PropTypes.func.isRequired,
};

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeviceModal: false,
      gateway: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.roadtest');
    this.handleSelectDevice = this.handleSelectDevice.bind(this);
    this.handleSelectGw = this.handleSelectGw.bind(this);
    this.handleRadius = this.handleRadius.bind(this);
  }

  componentWillMount() {
    this.handleSession();
  }

  handleSelectDevice(device) {
    let roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = { ...roadtest, device };

    this.setState({ device });
    sessionStorage.setItem('roadtest', JSON.stringify(roadtest));
    this.props.getDevice(device);
  }

  handleSelectGw(gateway = []) {
    let roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = { ...roadtest, gateway };

    this.props.getGateway(gateway);
    this.setState({ gateway, showGatewayModal: false });
    sessionStorage.setItem('roadtest', JSON.stringify(roadtest));
  }

  handleSession() {
    const { getDevice, getGpsColor, getGateway, getRadius } = this.props;
    const roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    const { device, icon, gateway, radius } = roadtest;

    if (!_.isNil(device)) {
      this.setState({ device });
      getDevice(device);
    }
    if (!_.isNil(icon)) {
      getGpsColor(icon);
    }
    if (!_.isNil(gateway)) {
      getGateway(gateway);
      this.setState({ gateway });
    }
    if (!_.isNil(radius)) {
      this.setState({ radius });
      getRadius(radius);
    }
  }

  handleRadius(radius) {
    this.props.getRadius(radius);
    this.setState({ radius });

    let roadtest = JSON.parse(sessionStorage.getItem('roadtest')) || {};
    roadtest = { ...roadtest, radius };
    sessionStorage.setItem('roadtest', JSON.stringify(roadtest));
  }

  handleReload() {
    this.props.updateGps(new Date().getTime());
    this.setState({ status: 'pending' });
    _.delay(() => {
      this.setState({ status: 'success' });
    }, 1000);
  }

  render() {
    const {
      radius = 1,
      showDeviceModal,
      device = {},
      gateway,
      showGpsModal = false,
      showGatewayModal = false,
      showRadiusModal = false,
      status = '',
    } = this.state;
    const { startDwnld } = this.props;

    const header = (
      <div className={`clearfix ${styles.leftTool}`}>
        {device.name &&
          <span className={styles.deviceName}>{device.name}</span>
        }
        <div className={`pull-left ${styles.addDps}`}>
          <Link
            className="fa fa-eyedropper"
            onClick={() => this.setState({ showGpsModal: true })}
          />
          <span>{this.intlMsg.msg('header.colorset')}</span>
        </div>
        <div className={`pull-left ${styles.addDps}`}>
          <Link
            className="fa fa-rss"
            onClick={() => this.setState({ showRadiusModal: true })}
          />
          <span>{this.intlMsg.msg('header.radius')}</span>
        </div>
        <div className="pull-right">
          <Button
            bsStyle="aisz-primary-b"
            onClick={() => this.setState({ showDeviceModal: true })}
          >
            {this.intlMsg.msg('selectdevice')}
          </Button>
          <Button
            bsStyle="aisz-default-b"
            onClick={() => this.setState({ showGatewayModal: true })}
            className={styles.marginLm}
          >
            {this.intlMsg.msg('selectgateway')}
          </Button>
          <Button
            bsStyle="aisz-info-b"
            className={styles.marginLm}
            onClick={() => startDwnld(new Date().valueOf())}
          >
            <i className="fa fa-download" />&nbsp;
            {this.intlMsg.msg('download')}
          </Button>
        </div>
      </div>
    );

    return (
      <Panel bsStyle="aisz-white" header={header} styleName="add-panel">
        <Row>
          <Col md={11}>
            <span className="pull-left">
              <TimeSelect />
            </span>
          </Col>
          <Col md={1} styleName="refresh">
            <Refresher
              onReload={() => this.handleReload()}
              reloading={status === 'pending'}
            />
          </Col>
        </Row>
        <DeviceModal
          checked={device}
          showModal={showDeviceModal}
          onHide={() => this.setState({ showDeviceModal: false })}
          onSelect={this.handleSelectDevice}
        />
        <SelectGatewayModal
          checked={gateway}
          showModal={showGatewayModal}
          onSuccess={this.handleSelectGw}
          onHide={() => this.setState({ showGatewayModal: false })}
        />
        <GpsColor
          showGpsModal={showGpsModal}
          onHide={() => this.setState({ showGpsModal: false })}
        />
        <CoverageModal
          radius={radius}
          showModal={showRadiusModal}
          onHide={() => this.setState({ showRadiusModal: false })}
          onConfirm={this.handleRadius}
        />
      </Panel>
    );
  }
}

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDevice: roadtestActions.getDevice,
  getGateway: roadtestActions.getGateway,
  getGpsColor: roadtestActions.getGpsColor,
  getRadius: roadtestActions.getRadius,
  updateGps: roadtestActions.updateGps,
  startDwnld: roadtestActions.startDwnld,
};

Header.propTypes = propTypes;

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(CSSModules(Header,
  styles,
)));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/coms/Header/index.jsx